import axios from 'axios';

//Symbol Currency Change.
export const DisplaySymbol = (currency: string) => {
  if (currency === 'USD' || currency === 'CAD') {
    return '$';
  } else if (currency === 'EUR') {
    return '€';
  } else if (currency === 'GBP') {
    return '£';
  }
};

//Using the endpoint Created
export const fetchRate = async (currency: string) => {
  const response = await axios(
    `https://esg-new-style-calculator.esgcalculator.com/api/data/GetConversionRates`,
    {
      headers: { 'Content-Type': 'application/json' },
      auth: {
        username: 'api-user',
        password: 'd3!56ze!dla(*a$da',
      },
    },
  );

  const exchangeRateCurrency = response.data.find(
    (rates: any) => rates.Code === currency,
  );
  const rates = Number(exchangeRateCurrency.Value.toFixed(2));
  return rates;
};
